import { render, staticRenderFns } from "./FunctionIcon.vue?vue&type=template&id=0f2a75f1&scoped=true&lang=html&"
import script from "./FunctionIcon.vue?vue&type=script&lang=js&"
export * from "./FunctionIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2a75f1",
  null
  
)

export default component.exports